import gql from 'graphql-tag';

export default gql`
  query {
    libraries(first: 1000) {
      edges {
        node {
          id
          name
        }
      }
    }
  }
`;
